import React, { ChangeEvent, FC, useState } from "react";
import { useValidator, ValidationType } from "./useValidator";

export type TextInputRenderer = (
  id: string,
  label: string,
  value?: string,
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
) => React.ReactElement;

export interface ValidationCallback {
  onValidationError?: (value: string) => void;
  onValidationSuccess?: (value: string) => void;
}

export interface TextInputProps {
  id: string;
  type: ValidationType;
  casing?: "uppercase" | "lowercase" | "default"
  label?: string;
  value?: string;
  callback?: ValidationCallback;
  renderer?: TextInputRenderer;
}

export const TextInput: FC<TextInputProps> = ({
  id,
  type,
  casing,
  label = "",
  value,
  callback,
  renderer,
}) => {
  const [innerValue, setInnerValue] = useState(value ?? "");

  const { isValid } = useValidator(type);

  const caseValue = (value: string, casing?: string) =>  {
    if("uppercase" === casing) {
      return value.toUpperCase()
    } else if("lowercase" === casing) {
      return value.toLowerCase()
    }
    return value
  }

  const onChange = (event: ChangeEvent<HTMLInputElement>)  => {
    const value = event.target.value;
    let cased = caseValue(value, casing)
    setInnerValue(cased);
    if (!isValid(cased)) {
      callback?.onValidationError && callback.onValidationError(cased);
    } else {
      callback?.onValidationSuccess && callback.onValidationSuccess(cased);
    }
  };

  return renderer ? (
    renderer(id, label, innerValue, onChange)
  ) : (
    <>
      {label}
      <input
        id={id}
        type="text"
        value={innerValue}
        onChange={onChange}
      />
    </>
  );
};
